import './Problem.css';

const pains = [
  {
    icon: '😤',
    accent: '#FF6B4A',
    title: '"Range ta chambre !"',
    desc: 'C\'est la 7ème fois que vous le dites ce aujourd\'hui, et ça n\'a toujours pas bougé.',
    tags: ['😩 Quotidien', '🔁 Répétitif'],
  },
  {
    icon: '🔁',
    accent: '#5B80F5',
    title: 'Les mêmes répétitions chaque jour',
    desc: 'Brosser les dents, éteindre la lumière, tirer la chasse… encore et encore.',
    tags: ['⏰ Chaque soir', '😮‍💨 Sans fin'],
  },
  {
    icon: '😰',
    accent: '#F84FA3',
    title: 'La culpabilité parentale',
    desc: 'Se sentir "mauvais parent" parce qu\'on a encore crié. Ce n\'est pas une fatalité.',
    tags: ['💔 Émotionnel', '🌍 Universel'],
  },
  {
    icon: '📱',
    accent: '#9B59F5',
    title: 'Les apps qui sur-stimulent',
    desc: 'Les solutions existantes créent une dépendance numérique. Ce n\'est pas ce que l\'on veut.',
    tags: ['📵 Dépendance', '⚠️ Contre-productif'],
  },
];

export default function Problem() {
  return (
    <section className="problem">
      <div className="problem__bg">
        <div className="problem__blob problem__blob--1" />
        <div className="problem__blob problem__blob--2" />
      </div>

      <div className="container">
        <div className="problem__header">
          <div className="section-label">🎯 Le constat</div>
          <h2 className="section-title">Vous vous reconnaissez ?</h2>
          <p className="section-subtitle">
            Chaque parent vit ces moments. Non pas par manque d'amour, mais parce que les routines, ç'est complexe à appréhender pour l'enfant — ça mérite donc un petit coup de pouce.
          </p>
        </div>

        <div className="problem__grid">
          {pains.map((pain, i) => (
            <div
              key={i}
              className="problem__card"
              style={{ '--pain-color': pain.accent }}
            >
              {/* Icône + numéro */}
              <div className="problem__card-header">
                <div className="problem__card-icon-wrap">
                  <span className="problem__card-icon">{pain.icon}</span>
                </div>
                <span className="problem__card-num">0{i + 1}</span>
              </div>

              {/* Contenu */}
              <div className="problem__card-body">
                <h3 className="problem__card-title">{pain.title}</h3>
                <p className="problem__card-desc">{pain.desc}</p>
                <div className="problem__card-tags">
                  {pain.tags.map((tag, j) => (
                    <span key={j} className="problem__card-tag">{tag}</span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="problem__solution-teaser">
          <div className="problem__solution-line" />
          <div className="problem__solution-text">
            <span className="problem__solution-icon">💡</span>
            <p>Il existe une autre façon de faire, plus douce et durable.</p>
            <a href="#fonctionnement" className="problem__solution-link">
              Découvrez Evolify <span>↓</span>
            </a>
          </div>
          <div className="problem__solution-line" />
        </div>
      </div>
    </section>
  );
}
